import {
  ClerkProvider,
  SignedIn,
  SignedOut,
  RedirectToSignIn,
  SignIn,
  SignUp,
} from "@clerk/clerk-react";
import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import { TokenProvider } from "./TokenProvider";
import PublicSignIn from "./micro/new_login_page/PublicSignIn";
import CustomLayout from "./micro/CustomLayout";
import PaymentProcessing from "./micro/profiles/PaymentProcessing";
import PublicCommitmentList from "./micro/PublicCommitmentList";
import PublicSchedule from "./micro/PublicSchedule";
import PublicVideoComponent from "./micro/submissions/PublicVideoComponent";
import PublicBadge from "./micro/PublicBadge";
import SeminarService from "./micro/seminar_service/SeminarService";
import BadgeScan from "./micro/BadgeScan";

if (!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Key");
}

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

class ClerkProviderWithRoutes extends React.Component {
  render() {
    return (
      <ClerkProvider
        publishableKey={clerkPubKey}
        navigate={(to) => this.props.history.push(to)}
      >
        <Switch>
          <Route exact path="/" component={PublicSignIn} />
          <Route exact path="/schedule" component={PublicSchedule} />
          <Route exact path="/c/:delegateId" component={PublicCommitmentList} />
          <Route exact path="/scan2" component={BadgeScan} />

          <Route
            exact
            path="/b/:delegateId/:delegateName/:badgeSpec"
            component={PublicBadge}
          />
          <Route
            path="/sign-in/*"
            component={() => <SignIn routing="path" path="/sign-in" />}
          />
          <Route
            path="/sign-up/*"
            component={() => <SignUp routing="path" path="/sign-up" />}
          />
          <Route
            exact
            path="/video/submission/:id"
            component={() => (
              <PublicVideoComponent
                routing="path"
                path="/video/submission/:id"
              />
            )}
          />
          <Route
            path="/conference"
            component={() => (
              <>
                <SignedIn>
                  <TokenProvider>
                    <CustomLayout />
                  </TokenProvider>
                </SignedIn>
                <SignedOut>
                  <RedirectToSignIn />
                </SignedOut>
              </>
            )}
          />
          <Route
            path="/processing-payment"
            component={() => (
              <>
                <SignedIn>
                  <TokenProvider>
                    <PaymentProcessing />
                  </TokenProvider>
                </SignedIn>
                <SignedOut>
                  <RedirectToSignIn />
                </SignedOut>
              </>
            )}
          />
          <Route exact path="/scan" component={SeminarService} />
        </Switch>
      </ClerkProvider>
    );
  }
}
function App() {
  return (
    <BrowserRouter>
      <ClerkProviderWithRoutes />
    </BrowserRouter>
  );
}

export default App;
